export const SEO_CONFIG: Record<string, { title: string; description: string }> = {
  bkmhouston: {
    title: 'BKM Houston',
    description: 'No.1 Tamil Non-Profit Organization in Houston',
  },
  mockingbird: {
    title: 'Mockingbird',
    description: 'Test description for Mockingbird',
  },
  bluebird: {
    title: 'Bluebird',
    description: 'Test description for Bluebird',
  },
  ciindians: {
    title: 'Cane Island Indians',
    description: 'Cane Island Indian community hub',
  },
};
